import { ca } from '@cian/analytics';

import { EDeviceType } from '../../types/device';
import { TOfferPin } from '../../types/map';

export function trackMapOpenClick(offerPins: TOfferPin[]) {
  const products = offerPins.map(offerPin => ({ id: offerPin.realtyOfferId }));

  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'Click',
    label: 'show_all_offers_on_map',
    products,
    page: {
      listingType: 'list',
      pageType: 'ListingFavorites',
      siteType: EDeviceType.Desktop,
    },
  });
}
